import { itemClicked, trackEvent } from '../../../app/browser/analyticsHelpers';
import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';

export default {
  identify: {},
  page: {
    name: 'SP : SP Profile : Reviews',
    properties: {
      ...defaultPageProps,
      userType: 'Authenticated',
    },
  },
  elements: {
    'request-reviews-cta--link': itemClicked('SP : SP Profile : Reviews', 'Request a Review'),

    'request-review-button': itemClicked('SP : Reviews', 'Request Reviews page - Click Copy Link Button'),

    'edit-retort--cancel-editing--*': trackEvent('Store Page - Review Tab - Retort Edit Canceled', {
      reviewId: '<<attributes.data-track-review-id.value>>',
      eventType: 'control',
      userType: 'Authenticated',
    }),
  },
};



// WEBPACK FOOTER //
// ./src/modules/store/browser/reviewAnalytics.js